<template>
    <div id="program-list" :class="channelClass">
        <div class="sched-program" v-for="(p, index) in progs" :key="index"  :id="`prog-${index}`" :date-str="`${p.date_str}`">
            <div class="time">
                <div>{{ p.time }}</div>
                <div class="watch-now" :class="channelClass" v-if="nowIndex == index"><a :href="channelLink" target="_blank">ON NOW</a></div>
            </div>
            <div class="img" v-if="channelClass != 'radio' "><img :src="`https://s3.amazonaws.com/3abn-sched-images/${p.program_code.slice(0,p.program_code.length - 6)}.jpg`" alt=""></div>
            <div class="info">
                <div class="title"><span class="series" :class="channelClass">{{ p.series_title }}</span><span class="bar" v-if="p.program_title ? p.program_title.trim() : null"> | </span><span class="program">{{ p.program_title }}</span></div>
                <div class="desc">
                    <span v-if="p.description"><b>Description:</b> {{ p.description }} <br/></span>
                    <span v-if="p.host"><b>Host:</b> {{ p.host }}<br/></span>
                    <span v-if="p.guest"><b v-if="channelClass !== 'radio'">Guest:</b> {{ p.guest }}<br/></span>
                    <!-- <b>Date:</b> {{ p.date }}<br> -->
                    <!-- <b>Channel:</b> {{ p.channel }}<br> -->
                </div>
                <div class="misc">{{ p.program_code }} &emsp; {{ p.rating }} &emsp; {{ p.duration }}</div>
            </div>
            <!-- <div class="watch-now" :class="channelClass" v-if="nowIndex == index"><a :href="channelLink" target="_blank"><span>Watch Now</span><i class="fa fa-play"></i></a></div> -->
        </div>
    </div>
</template>

<script>
import bowser from 'bowser'
export default {
    name: 'progList',
    data() {
        return {}
    },
    computed: {
        progs() {
            return this.$store.state.sched[this.day]
        },
        day() {
            return this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateC
        },
        nowIndex() {
            let x = this.progs.filter(n => {
                return Date.now() < Date.parse(n.date_str)
            })

            if (!bowser.msie) {
                var y = this.progs.findIndex(n => {
                    return n == x[0]
                })
            }


            // console.log(y)
            return y - 1
        },
        channelLink() {
            let baseURL = "http://3abn.org/all-streams/"
            let currentChannel = this.$store.state.channel
            if (currentChannel == 'main') { return `${baseURL}index.html` }
            if (currentChannel == 'proc') { return `${baseURL}proclaim.html` }
            if (currentChannel == 'dare') { return `${baseURL}daretodream.html` }
            if (currentChannel == 'int') { return `${baseURL}international.html` }
            if (currentChannel == 'kids') { return `${baseURL}kids.html` }
            if (currentChannel == 'lat') { return `${baseURL}latino.html` }
            if (currentChannel == 'radio') { return `http://3abn.org/3abn-radio-broadcast.html` }
        },
        channelClass() {
            return this.$store.state.channel
        }
    },
    mounted() {
        try {
            if(window.sched_config.resize) {
            let innerHeight = window.innerHeight
            let programList = document.getElementById('program-list')

            function resize() {
                programList.style.height = (innerHeight - programList.offsetTop) + 'px'
            }

            resize()

            window.addEventListener("resize", function() {
                innerHeight = window.innerHeight
                resize()
            })
        }
        } catch (err) {}



        // get all the programs and scroll the appropriate into view
        let programs = [].slice.call(document.getElementsByClassName('sched-program'))

        let afterNow = programs.filter(n => {
            return Date.now() < Date.parse(n.getAttribute('date-str'))
        })

        if (!bowser.msie) {
            var nowIndex = programs.findIndex(n => {
                return n === afterNow[0]
            }) - 1
        }



        let programsList = document.getElementById('program-list')
        let now

        if (programs[nowIndex]) {
            now = programs[nowIndex]
            programsList.scrollTop = now.offsetTop - programsList.offsetTop
        }







        // b.scrollTop = offsetTop
    }
}
</script>



// WEBPACK FOOTER //
// src/components/prog-list.vue